import { render } from "./chip.vue?vue&type=template&id=8ca08cee&scoped=true"
import script from "./chip.vue?vue&type=script&lang=js"
export * from "./chip.vue?vue&type=script&lang=js"

import "./chip.vue?vue&type=style&index=0&id=8ca08cee&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2161826209/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca08cee"]])

export default __exports__